module.exports = __webpack_public_path__ + "img/alpine.f05c713e.jpg";